/**
 * El enlace de una invitación al equipo, que tiene que sobrevivir al login.
 *
 * Mismo problema y misma solución que en [`transferInvite`](./transferInvite.ts),
 * y por la misma razón de fondo: se invita a un CORREO, así que quien abre el
 * enlace muchas veces no tiene cuenta todavía y el camino normal pasa por
 * registrarse. La aplicación reescribe a `/login` cualquier ruta sin sesión, y
 * ahí el token se perdía.
 *
 * Separado del de traspaso y no compartiendo la clave: las dos invitaciones
 * pueden estar vivas a la vez —una agencia que entrega un sitio y a la vez te
 * mete en otro— y con una sola clave la segunda pisaría a la primera.
 *
 * En `sessionStorage` y no en `localStorage`, también igual: es de ESTA visita.
 */
const KEY = 'veltica:team-invite'

/** El token si la dirección actual es la de una invitación al equipo. */
export function teamTokenFromPath(pathname = window.location.pathname): string | null {
  const match = /^\/equipo\/([A-Za-z0-9._-]{20,200})\/?$/.exec(pathname)
  return match?.[1] ?? null
}

export function rememberTeamToken(token: string): void {
  try { sessionStorage.setItem(KEY, token) } catch { /* modo privado */ }
}

export function readTeamToken(): string | null {
  try { return sessionStorage.getItem(KEY) } catch { return null }
}

/**
 * Lo lee y lo borra a la vez.
 *
 * Se consume al abrir la pantalla y no al aceptar: dejarlo puesto haría que
 * quien rechaza y sigue navegando volviera a caer en la invitación en cada
 * recarga.
 */
export function consumeTeamToken(): string | null {
  const token = readTeamToken()
  try { sessionStorage.removeItem(KEY) } catch { /* modo privado */ }
  return token
}
